import {FC, useCallback} from "react";
import {makeStyles} from "tss-react/mui";
import {Box} from "@mui/material";
import {AdminHeader} from "@/pages/ManagerView/AdminHeader";
import {useNavigate} from "react-router-dom";
import {useOwnedCohort} from "@/app2/shared/hooks";
import {CoursesListGrid} from "./CoursesListGrid";

const useStyles = makeStyles()((theme) => ({
	adminCoursesList: {
		"& svg path": {
			fill: theme.palette.common.white
		},
		"& th": {
			fontSize: "11px",
			fontWeight: 700,
			textTransform: "uppercase"
		}
	}
}));

/**
 * Admin Courses List (App2)
 * 
 * Uses React Query and DataGridPro instead of legacy useApi and AdminTable.
 */
export const AdminCoursesList: FC = () => {
	const {classes} = useStyles();
	const navigate = useNavigate();
	const ownedCohort = useOwnedCohort();

	const cohort = typeof ownedCohort === "object" ? ownedCohort : undefined;

	const onCreateClick = useCallback(() => {
		// Route to new app2 editor
		navigate("create-new");
	}, [navigate]);

	return (
		<Box className={classes.adminCoursesList}>
			<AdminHeader
				title="Courses"
				subtitle="Manage courses, enroll them into courses and check their capacity"
				actionButtons={[{label: "Create New", onClick: onCreateClick}]}
			/>
			<CoursesListGrid
				ownedCohortTitle={cohort?.title}
			/>
		</Box>
	);
};
